module.exports = __webpack_public_path__ + "img/JinBi.f7b78d60.png";